export const TipoVenta = {
    P: "EN PIE",
    E: "FERIA",
    F: "FRIGORÍFICO"
};